import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = "https://taskpro-backend-i4f0.onrender.com/api/auth";

export const registerUser = createAsyncThunk(
  "auth/register",
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(`${API_URL}/register`, formData);
      await new Promise((resolve) => setTimeout(resolve, 2500));
      return res.data;
    } catch (error) {
      await new Promise((resolve) => setTimeout(resolve, 2500));
      return thunkAPI.rejectWithValue(
        error.response.data.message || "Registration failed"
      );
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/login",
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(`${API_URL}/login`, formData);
      await new Promise((resolve) => setTimeout(resolve, 2500));
      return res.data;
    } catch (error) {
      await new Promise((resolve) => setTimeout(resolve, 2500));
      return thunkAPI.rejectWithValue(
        error.response.data.message || "Login failed"
      );
    }
  }
);

export const updateProfile = createAsyncThunk(
  "auth/profile",
  async (formData, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;

      const res = await axios.put(`${API_URL}/profile`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response.data.message || "Update profile failed"
      );
    }
  }
);
